import { createApiRef, DiscoveryApi, IdentityApi } from '@backstage/core-plugin-api';

export const quartermasterApiRef = createApiRef<QuartermasterApi>({
  id: 'plugin.otk-quartermaster.service',
});

export interface QuartermasterApi {
  listTeamspaceNamespaces(options: {
    team: string;
  }
  ): Promise<ClusterNamespace[]>;

  getAppConfigEnv(options: {
    ns: string;
    cluster: string;
  }
  ): Promise<AppConfigEnvs>;
}

export interface QuartermasterApiClientOptions {
  discoveryApi: DiscoveryApi;
  identityApi: IdentityApi;
}

export interface ClusterNamespace {
  cluster: string;
  namespace: string;

  annotations: { [key: string]: string };
  labels: { [key: string]: string };
}

export interface AppConfigEnvs { [key: string]: string };

/**
 * API to talk to quartermaster service.
 */
export class QuartermasterApiClient implements QuartermasterApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly identityApi: IdentityApi;

  constructor(options: {
    discoveryApi: DiscoveryApi;
    identityApi: IdentityApi;
  }) {
    this.discoveryApi = options.discoveryApi;
    this.identityApi = options.identityApi;
  }

  async listTeamspaceNamespaces(options: {
    team: string;
  }): Promise<ClusterNamespace[]> {
    const { team } = options;

    const url = new URL(
      `${await this.discoveryApi.getBaseUrl(
        'proxy',
      )}/quartermaster/clusters/-/namespaces?team=${encodeURIComponent(team)}`,
    );

    const idToken = await this.getToken();
    const response = await fetch(url.href, {
      method: 'GET',
      headers: {
        ...(idToken && { Authorization: `Bearer ${idToken}` }),
      },
    });

    console.log("response.status")
    console.log(response.status)

    return (
      (await response.json()) || []
    );
  }

  async getAppConfigEnv(options: {
    ns: string;
    cluster: string;
  }): Promise<AppConfigEnvs> {
    const { ns, cluster } = options;

    const url = new URL(
      `${await this.discoveryApi.getBaseUrl(
        'proxy',
      )}/quartermaster/clusters/${encodeURIComponent(cluster)}/namespaces/${encodeURIComponent(ns)}/app-config-env`,
    );

    const idToken = await this.getToken();
    const response = await fetch(url.href, {
      method: 'GET',
      headers: {
        ...(idToken && { Authorization: `Bearer ${idToken}` }),
      },
    });

    return (
      (await response.json()) || []
    );
  }

  private async getToken() {
    const { token } = await this.identityApi.getCredentials();
    return token;
  }

}